import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  adminToolBookStatementTeacherCourseList: {
    state: '',
    list: [],
    total: 0,
  },

  teacherBookCatalogCreate: {
    book_statement_provider_id: ''
  },
  teacherBookDiscount: {
    scope: 'all',
    discount: '',
  },
};

const getters = {
  geTeacherBookCatalogCreate: (state) => state.teacherBookCatalogCreate,
  getTeacherBookDiscount: (state) => state.teacherBookDiscount,
  getAdminToolBookStatementTeacherCourseList: (state) => state.adminToolBookStatementTeacherCourseList,
};

const mutations = {
  [types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_COURSE_LIST]({adminToolBookStatementTeacherCourseList}, result){
    extend(adminToolBookStatementTeacherCourseList, result)
  },
  [types.TEACHER_BOOK_CATALOG_CREATE]({teacherBookCatalogCreate}, result){
    extend(teacherBookCatalogCreate, result)
  },
  [types.TEACHER_BOOK_DISCOUNT]({teacherBookDiscount}, result){
    extend(teacherBookDiscount, result)
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/teacherTextBookSchedule/index.js